export default __webpack_public_path__ + "static/media/misc-fireplaceA-1024w.7c401487.avif";